import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sites/$siteSlug/forms/$formId')({
  component: FormLayout,
});

function FormLayout() {
  return <Outlet />;
}
